import styled from 'styled-components/macro';

const Info = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 9px;

  span {
    font-size: 12px;
  }
`;

export default Info;
